// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"TermsOfUse_textWrapper__s7L6x"};